import { OrganizationSizeEnum } from '@/shared/types/graphql/globals.v4.b2b';

export const COMPANY_SIZE_OPTIONS = [
  { value: OrganizationSizeEnum.SIZE_MAX_250, label: 'FORM_COMPANY_SIZE_250' },
  {
    value: OrganizationSizeEnum.SIZE_MAX_1000,
    label: 'FORM_COMPANY_SIZE_MORE_250',
  },
  {
    value: OrganizationSizeEnum.SIZE_MORE_THAN_1000,
    label: 'FORM_COMPANY_SIZE_1000',
  },
];

export const B2B_RESOURCES_DOWNLOADABLE_DETAIL =
  'Resource Downloadable Detail B2B';

export const itemTypes: { [key: string]: 'tool' | 'ebook' | 'tutorial' } = {
  herramientas: 'tool',
  ebooks: 'ebook',
  tutoriales: 'tutorial',
};
